import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

import { computed } from 'vue';

interface Props {
  // ダイアログを表示するかどうか
  display: boolean;
  // ダイアログのサイズ可変
  largesize?: boolean;
  // エラーレベル（error、warning、information）
  level: string;
  // ボタンがOKのみのダイアログかどうか
  confirmation?: boolean;
  // ダイアログ内ヘッダータイトル
  title: string;
  // ダイアログ内本文
  text: Array<string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertDialog',
  props: {
    display: { type: Boolean },
    largesize: { type: Boolean },
    level: {},
    confirmation: { type: Boolean },
    title: {},
    text: {}
  },
  emits: ["confirm", "complete", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const dialog = computed(() => props.display);

const emit = __emit;

const dialogOk = () => {
  if (props.confirmation || props.level === 'error') {
    emit('complete');
  } else {
    emit('confirm');
  }
};

const dialogClose = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    persistent: "",
    class: "alertdialog-area"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, {
            class: _normalizeClass(props.level)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_avatar, null, {
                default: _withCtx(() => [
                  (props.level === 'error')
                    ? (_openBlock(), _createBlock(_component_q_icon, {
                        key: 0,
                        name: "mdi-close-circle"
                      }))
                    : (props.level === 'warning')
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 1,
                          name: "mdi-alert"
                        }))
                      : (_openBlock(), _createBlock(_component_q_icon, {
                          key: 2,
                          name: "mdi-alert-circle"
                        }))
                ]),
                _: 1
              }),
              _createVNode(_component_q_toolbar_title, { class: "text-weight-bold" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.text, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: "main-content"
                }, [
                  _createElementVNode("p", null, _toDisplayString(item), 1)
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "right",
            class: "text-primary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                color: "primary",
                label: "OK",
                onClick: dialogOk
              }),
              (!_ctx.confirmation && props.level !== 'error')
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    label: "キャンセル",
                    outline: "",
                    style: {"color":"var(--q-delete)","margin-left":"12px"},
                    onClick: dialogClose
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})